// extracted by mini-css-extract-plugin
export default {"Vertical":"WSList-module_Vertical-R5YNh","Horizontal":"WSList-module_Horizontal-lt9nH","equalItems":"WSList-module_equalItems-E2FPW"};